import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AlertService } from 'src/services/alert-service.service';
import { NetworkService } from 'src/services/network/network.service';

@Component({
  selector: 'app-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.scss']
})
export class UploadFileComponent implements OnInit {
  @Input() userId = '';
  @Input() label = 'Upload';
  @Input() viewType = 'fill';
  @Input() isUploaded = false;
  @Input() userType = 'ADMIN';
  @Input() buttonName = 'Upload';
  @Input() showCloseIcon: boolean | undefined;
  @Input() uploadType: 'OWN' | 'DOCUMENT' = 'OWN';
  @Input() imageSource = '/assets/image/bannerx.jpg';
  @Input() id: string = (Math.random() * 100).toFixed(2);
  @Input() multiple: Boolean = false;
  @Input() imagePreview: string | undefined = '/assets/image/bannerx.jpg';
  @Input() imageValidation: boolean = false
  @Output() uploadImage = new EventEmitter();
  @Output() removeImage = new EventEmitter();

  constructor(
    private networkService: NetworkService,
    private alert: AlertService,
    private ngxUiLoader: NgxUiLoaderService
  ) {
  }

  ngOnChanges() {
  }

  ngOnInit(): void {
  }

  clearInput(): void {
    this.isUploaded = false;
    this.imagePreview = 'assets/image/bannerx.jpg';
    this.removeImage.emit(this.imageSource);
  }

  upload(event: any): any {
    const file = event.target.files[0];
    const reader = new FileReader();
    // reader.onload = () => this.imageSource = reader.result as string;
    reader.readAsDataURL(file);
    if (this.imageValidation === false) {
      reader.onload = (e: any) => {
        var image = new Image();
        image.src = e.target.result;
        image.onload = (e: any) => {
          var height = e?.path ? e?.path[0]?.height : 100;
          var width = e?.path ? e?.path[0]?.width : 100;
          if(height > 4000 || width > 4000){
            this.alert.showAlert('Image must be less than 10MB', 'warning');
          }
           else {
            this.updateData(event);
          }
        };
      }
    } else {
      this.updateData(event);
    }

  }


  updateData(event: any) {
    if (!this.multiple) {
      this.isUploaded = true;
    }

    const formData = new FormData();

    formData.append('files', event.target.files[0], event.target.files[0].name);
    formData.append('userType', this.userType);

    if (this.userId) {
      formData.append('userId', this.userId);
    }

    this.ngxUiLoader.start();
    this.networkService.httpFormRequest(
      this.uploadType === 'OWN'
        ? '/media/admin/files'
        : '/media/admin/users/documents'
      , formData)
      .then((response: any) => {
        this.uploadImage.emit(response.data[0]);
        this.imagePreview = response.data[0].preview;
      })
      .catch(err => {
        this.alert.showAlert();
      })
      .finally(() => {
        this.ngxUiLoader.stop();
      });
  }
}
